import React, { useEffect } from 'react';
import Meta from './../components/Meta';
import AdminAuthSection from './../components/auth/AdminAuthSection';
import { useAuth } from './../util/auth';
import { useRouter } from './../util/router';

function AdminLoginPage(props) {
  const auth = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (auth.user && auth.user.user_type) {
      router.replace('/admin/dashboard');
    }
  }, [auth.user, router]);

  return (
    <>
      <Meta title="Admin Sign In" />
      <AdminAuthSection />
    </>
  );
}

export default AdminLoginPage;
